module.exports = __webpack_public_path__ + "img/989.9235ab6c.png";